<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <!-- <label>Position</label> -->
          <v-select
            :value="fields['card-left']"
            :items="postionOptions"
            label="Title Position"
            @change="handleChangePositionLeft"
          />

          <v-row>
            <v-col cols="4">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['text-color']"
                      @change="handleChangeTextColor"
                    />
                    <v-text-field v-model="fields['text-color']" label="Text Color" />
                    <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="4">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['background-color']"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field v-model="fields['background-color']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="4">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="border-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['border-color']"
                      @change="handleChangeBorderColor"
                    />
                    <v-text-field v-model="fields['border-color']" label="Border Color" />
                    <v-btn @click="handleResetBorderColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="mb-7">
            <label>title</label>
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
          </div>

          <div style="margin-bottom: 20px">
            <div>
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="head"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colorPercent']"
                  @change="handleChangeColorPercent"
                />
                <v-text-field v-model="fields['colorPercent']" label="Color Percent" />
              </div>
            </div>
          </div>
          <div class="mb-7">
            <div class="d-flex justify-space-between align-center">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label style="margin-bottom: 0">Survey</label>
              </div>
              <v-btn small text color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Survey {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="wrap-product-form">
                    <v-text-field outlined v-model="item.percent" label="Percent" type="number" min="0" max="100" />
                    <v-textarea outlined type="textarea" v-model="item.description" label="Description" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'card-with-survey-text-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        {
          text: 'Left',
          value: 1,
        },
        {
          text: 'Right',
          value: 2,
        },
      ],
      fields: {
        title: '',
        'card-left': 1,
        'card-right': 2,
        'card-title': '',
        listItem: [
          {
            percent: 0,
            description: '',
          },
        ],
        colorPercent: '#000000',
        'text-color': '#000000',
        'background-color': '',
        'border-color': '#e5e7eb',
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleChangeColorPercent(event) {
      this.fields['colorPercent'] = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleChangeBorderColor(event) {
      this.fields['border-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '#000000';
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
    handleResetBorderColor() {
      this.fields['border-color'] = '#e5e7eb';
    },
    handleAddItem() {
      this.fields['listItem'].push({
        percent: 0,
        description: '',
      });
    },
    handleRemoveItem(index) {
      this.fields['listItem'].splice(index, 1);
    },
    handleChangePositionLeft(value) {
      this.fields['card-left'] = Number(value);
      if (value === 1) {
        this.fields['card-right'] = 2;
      } else {
        this.fields['card-right'] = 1;
      }
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTextSurvey(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
